import React from 'react'
import Imag from "../../images/values.jpg";
import { values } from "../../data";
import SeactionHeader from '../seactionheader/SeactionHeader';
import { GiCutDiamond } from "react-icons/gi";
import Card from '../../ui/Card';

function Values() {
  return (
    <section className='value'>
        <div className="container container__value">
            <div className="value__left">
                <div className="value__image">
                    <img src={Imag} alt="Imag" />
                </div>
            </div>
            <div className="value__right">
                    <SeactionHeader icon={<GiCutDiamond/>} title="values"/>

                    
                        <p>
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Natus sed alias ad eveniet laudantium optio enim vitae saepe sunt inventore, autem distinctio adipisci praesentium assumenda. Ad, distinctio mollitia? Aliquam, quibusdam?
                        </p>
                        <div className="value__wrapper">
                            {
                                values.map(({id, icon, title, desc}) =>{
                                    return <Card className="values__value" key={id}>
                                            <span>{icon}</span>
                                            <h4>{title}</h4>
                                            <small>{desc}</small>
                                    </Card>
                                })
                            }
                        </div>

                    
            </div>
        </div>
        
    </section>
  )
}

export default Values